import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { ButtonCardComponent } from './components/button-card/button-card.component';
import { MenuComponent } from './components/menu/menu.component';
import {
    ICC_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER,
    MenuTriggerDirective,
} from './components/menu/menu-trigger.directive';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { MenuItemComponent } from './components/menu/menu-item.component';
import { IconComponent } from './components/icon/icon.component';
import { InputComponent } from './components/input/input.component';
import { SelectComponent } from './components/select/select.component';
import { InplaceComponent, InplaceFocusDirective } from './components/inplace/inplace.component';
import { TemplateDirective } from './template.directive';
import { ModalComponent } from './components/modal/modal.component';
import { CalculationIndicatorComponent } from './components/calculation-indicator/calculation-indicator.component';
import {
    ChipComponent,
    ChipSmallDirective,
    ChipStatusDirective,
} from './components/chip/chip.component';
import {
    CheckboxComponent,
    ICC_CHECKBOX_CONTROL_VALUE_ACCESSOR,
} from './components/checkbox/checkbox.component';
import { FormsModule } from '@angular/forms';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { LabelComponent } from './components/label/label.component';
import { RadioComponent } from './components/radio/radio.component';
import { BadgeChipComponent } from './components/badge-chip/badge-chip.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { BadgeDirective } from './components/badge/badge.directive';
import { TranslateModule }  from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        PortalModule,
        OverlayModule,
        A11yModule,
        FormsModule,
        MatDatepickerModule,
        MatDateFnsModule,
        TranslateModule,
    ],
    declarations: [
        ButtonComponent,
        ButtonCardComponent,
        MenuComponent,
        MenuTriggerDirective,
        MenuItemComponent,
        IconComponent,
        InputComponent,
        SelectComponent,
        InplaceComponent,
        TemplateDirective,
        ModalComponent,
        CalculationIndicatorComponent,
        ChipComponent,
        ChipSmallDirective,
        ChipStatusDirective,
        CheckboxComponent,
        FormFieldComponent,
        LabelComponent,
        RadioComponent,
        BadgeChipComponent,
        BadgeDirective,
        InplaceFocusDirective,
    ],
    exports: [
        ButtonComponent,
        ButtonCardComponent,
        MenuComponent,
        MenuTriggerDirective,
        MenuItemComponent,
        IconComponent,
        InputComponent,
        SelectComponent,
        InplaceComponent,
        TemplateDirective,
        ModalComponent,
        CalculationIndicatorComponent,
        ChipComponent,
        ChipSmallDirective,
        ChipStatusDirective,
        CheckboxComponent,
        FormFieldComponent,
        LabelComponent,
        RadioComponent,
        BadgeChipComponent,
        BadgeDirective,
        InplaceFocusDirective,
    ],
    providers: [
        ICC_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER,
        MatDatepickerModule,
        MatDateFnsModule,
    ]
})
export class UiModule {}
